export default {
  path: 'privacy-notice',
  name: 'privacy-notice',
  redirect: { name: 'privacy-notice.index' },
  children: [
    {
      path: '',
      name: 'privacy-notice.index',
      component: () => import('pages/privacy-notice/IndexPage.vue'),
    },
    {
      path: 'update',
      name: 'privacy-notice.update',
      component: () => import('pages/privacy-notice/UpdatePage.vue'),
    },
  ],
}
